import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PageScanRequest from "./PageScanRequest/PageScanRequest";
import QuarterlyGoals from "./QuarterlyGoals/QuarterlyGoals";
import PerformanceDashboard from "./PerformanceDashboard/PerformanceDashboard";
import "./PageSpeedPerformanceTabs.css";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useDispatch } from "react-redux";
import {
  setGoalsRequestedBy,
  setRequestedBy,
  setSelectedDevice,
  setSelectedGoalsDate,
  setSelectedPage,
  setSelectedStatus,
} from "../../../../features/pageSpeedPerformanceSlice";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PageSpeedPerformanceTabs() {
  const [value, setValue] = useState(0);
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
    dispatch(setSelectedStatus(null));
    dispatch(setRequestedBy(null));
    dispatch(setSelectedGoalsDate(null));
    dispatch(setSelectedDevice(null));
    dispatch(setGoalsRequestedBy(null));
    dispatch(setSelectedPage(null));
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.delete("deviceTab1");
      updatedParams.delete("intervalTab1");
      updatedParams.delete("quarterTab1");
      updatedParams.delete("selectedPeriodTab1");
      updatedParams.delete("pageTopRated");
      updatedParams.delete("pageBottomRated");
      updatedParams.delete("search");
      updatedParams.delete("filters");
      updatedParams.delete("pageScanPage");
      updatedParams.delete("quarterlyGoalsPage");

      updatedParams.set("tab", newValue.toString()); // Update 'tab' param
      return updatedParams;
    });
  };

  const hasViewPageSpeedPerformanceDashboard = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "view_page_speed_performance"
  );
  const hasViewPsiResults = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "view_psi_results"
  );
  const hasViewQuarterlySpeedResults = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "view_quarterly_speed_goals"
  );
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const tabFromParams = searchParams.get("tab");
    if (tabFromParams) {
      setValue(Number(tabFromParams)); // Load tab index from URL
    }
    // eslint-disable-next-line
  }, [searchParams.get("tab")]);

  // when the component unmounts the the selectedPage value should be null
  useEffect(() => {
    return() => {
      dispatch(setSelectedPage(null)) // when unmount the component 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            indicatorColor="secondary"
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              "& .MuiTab-root": {
                color: "#00000099", // Default color for unselected tabs
                "&.Mui-selected": {
                  color: "#9C27B0", // Change color when the tab is selected
                },
              },
              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },
              "& .MuiTab-root:first-of-type": {
                paddingLeft: 0,
              },
            }}
          >
            {hasViewPageSpeedPerformanceDashboard ? (
              <Tab
                label="Performance Dashboard"
                sx={{ paddingLeft: "10px" }}
                {...a11yProps(0)}
              />
            ) : (
              <Tab
                label="Performance Dashboard"
                sx={{ paddingLeft: "10px" }}
                disabled
              />
            )}
            {hasViewPsiResults ? (
              <Tab label="Page Scan Requests" {...a11yProps(1)} />
            ) : (
              <Tab label="Page Scan Requests" disabled />
            )}
            {hasViewQuarterlySpeedResults ? (
              <Tab label="Quarterly Goals" {...a11yProps(2)} />
            ) : (
              <Tab label="Quarterly Goals" disabled />
            )}
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <PerformanceDashboard value={value} setValue={setValue} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <PageScanRequest />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <QuarterlyGoals />
        </CustomTabPanel>
      </Box>
    </>
  );
}
